import { Header2, Paragraph2 } from '@cian/ui-kit';
import classNames from 'classnames';
import React, { memo } from 'react';

import styles from './Price.css';
import { ContentRow } from '../ContentRow';
import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';

interface IPriceProps {
  priceInfo?: string;
  price: string;
  isHighlighted?: boolean;
  MortgageAdFoxBanner?: React.ReactNode;
}

/** Компонент цены */
export const PriceComponent: React.FC<IPriceProps> = ({ priceInfo, price, isHighlighted, MortgageAdFoxBanner }) => {
  return (
    <GeneralInfoSectionRow>
      <ContentRow>
        <Header2 data-mark="MainPrice">
          <span className={classNames(isHighlighted && styles['highlighted'])}>{price}</span>
        </Header2>
      </ContentRow>
      {priceInfo && (
        <ContentRow>
          <Paragraph2 data-mark="PriceInfo" color="gray60_100">
            {priceInfo}
          </Paragraph2>
        </ContentRow>
      )}
      {MortgageAdFoxBanner}
    </GeneralInfoSectionRow>
  );
};

PriceComponent.displayName = 'Price';

/** @see {@link PriceComponent} */
export const Price = memo(PriceComponent);
